import { useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { useSelector } from "react-redux";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import Alert from "@material-ui/lab/Alert";
import { auth } from "../../firebase";

const validationSchema = yup.object({
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match")
    .required("Required field"),
  password: yup
    .string()
    .min(8, "Type 8 characters or more. Use letters, numbers and symbols.")
    .required("Required field"),
  currentPassword: yup
    .string()
    .min(8, "Type 8 characters or more. Use letters, numbers and symbols.")
    .required("Required field"),
});

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 10000,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function Profile() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [messageSuccess, setMessageSuccess] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const { currentUser = {} } = useSelector((state) => ({
    currentUser: state.currentUser,
  }));
  const formik = useFormik({
    initialValues: {
      password: "",
      currentPassword: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateUserPassword(values);
    },
  });

  console.log(formik);

  const updateUserPassword = (values) => {
    setLoading(true);
    auth
      .signInWithEmailAndPassword(currentUser.email, values.currentPassword)
      .then((resp) => {
        auth.currentUser
          .updatePassword(values.password)
          .then(() => {
            setLoading(false);
            formik.resetForm()
            setMessageError(false);
            setMessageSuccess("Password updated successfully");
          })
          .catch((error) => {
            setLoading(false);
            setMessageSuccess(false);
            setMessageError(error.message);
          });
      })
      .catch((err) => {
        setLoading(false);
        setMessageSuccess(false);
        setMessageError(err.message);
      });
  };

  // confirm passwrod match
  const validateConfirmPassword = (pass, e) => {
    const value = e.target.value;
    formik.setFieldValue("confirmPassword", value);
    if (pass && value) {
      if (pass !== value) {
        formik.setFieldError("Password not matched");
      }
    }
  };
  return (
    <>
    <Backdrop open={loading} className={classes.backdrop}>
      <CircularProgress style={{ width: 30, height: 30 }} color="inherit" />
    </Backdrop>
    <form className={classes.form} onSubmit={formik.handleSubmit}>
      <Typography component="h1" variant="h5">
        Change Password
      </Typography>
      {messageSuccess && <Alert severity="success">{messageSuccess}</Alert>}
      {messageError && <Alert severity="error">{messageError}</Alert>}
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            name="currentPassword"
            label="Current Password"
            type="password"
            id="currentPassword"
            value={formik.values.currentPassword}
            onChange={formik.handleChange}
            error={
              formik.touched.currentPassword &&
              Boolean(formik.errors.currentPassword)
            }
            helperText={
              formik.touched.currentPassword &&
              formik.errors.currentPassword
            }
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            error={
              formik.touched.password && Boolean(formik.errors.password)
            }
            helperText={formik.touched.password && formik.errors.password}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            variant="outlined"
            fullWidth
            name="confirmPassword"
            label="Confirm Password"
            type="password"
            id="confirmPassword"
            value={formik.values.confirmPassword}
            onChange={(value) =>
              validateConfirmPassword(formik.values.password, value)
            }
            error={
              formik.touched.confirmPassword &&
              Boolean(formik.errors.confirmPassword)
            }
            helperText={
              formik.touched.confirmPassword &&
              formik.errors.confirmPassword
            }
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Change Password
      </Button>
    </form>
    </>
  );
}
